module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgB7ZaxDcIwEEUNVHTZAI9ASZmSkpLSI2QDsgFskGzACCkpMwKUdGEDOKOzdDnFxxlE55OeFEx8/zWR/sIYswMuwBaYAQ8kZQpgAxyAFtgDS+Cu2eUvPBkd4AD7IbQEGmCY2BHogUra1eKLsSVURhuaJNOSIIthXWTBEDk7oZgj5wX+Pgsyay5AxwoyNJQOFaATk2kkAS4TLtXCe85MC3CZPgjMjW5ukedvZvSVaQX+NlkgC2SBLJAFskAWoAIF8susyLPVXKACvp/5quVrk0uQKYEj3q3J+dXo2vU7OFQkDpUJZ46Faoorb9ehZzZUxP9RCTISAy4rUdYaXbseCaTK8FBpl4vINEYxlshoQzUyftfuBRvrsSj+uwVzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vector.png
// module id = 7NO4
// module chunks = 1